import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const FactoryIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 13.596 13.217">
      <g transform="translate(-1240.014 -671.457)">
        <g transform="translate(1240.114 671.565)">
          <path
            d="M1246.812,671.565l-6.7,2.679v10.33h2.512v-6.7H1251v6.7h2.512v-10.33Zm5.86,12.172h-.837v-6.7h-10.047v6.7h-.838v-8.926l5.861-2.345,5.86,2.345Z"
            transform="translate(-1240.114 -671.565)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
          <path
            d="M1251.083,688.836h-2.063v2.75h4.812v-4.812h-2.75Zm0,2.063h-1.375v-1.375h1.375Zm.687-3.438h1.375v1.375h-1.375Zm0,2.062h1.375V690.9h-1.375Z"
            transform="translate(-1244.808 -678.577)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
          <rect
            width="0.902"
            height="0.902"
            transform="translate(3.748 3.363)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
          <rect
            width="2.707"
            height="0.902"
            transform="translate(5.344 3.363)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
          <rect
            width="0.902"
            height="0.902"
            transform="translate(8.746 3.363)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
